import './Contact.css'
// import Link from '../../assets/icons/link.svg'
import Github from '../../assets/icons/github.svg'
import Facebook from '../../assets/icons/facebook.svg'
import Linkedin from '../../assets/icons/linkedin.svg'
import Mail from '../../assets/icons/mail.svg'
import Whatsapp from '../../assets/icons/whatsapp.svg'

import { AiFillGithub, AiOutlineWhatsApp, AiFillMail } from "react-icons/ai";
import {FaFacebook} from 'react-icons/fa'
import {IoLogoLinkedin} from 'react-icons/io'

// import linkedin from '../../assets/icons/linkedin-svgrepo-com.svg'

const Contact = () => {
  return (
    <div className="section" id="contact">
      <div className="contact-content">
        <h1>Contact Me</h1>
        <div className="contact-links">
          <a
            href="https://www.facebook.com/ahmedsameh610/"
            target="_blank"
            rel="noreferrer"
          >
            {/* <img src={Facebook} alt="facebook" /> */}
          <FaFacebook/>
          </a>
          <a
            href="https://www.linkedin.com/in/ahmedsameh610/"
            target="_blank"
            rel="noreferrer"
          >
            {/* <img src={Linkedin} alt="linkedin" /> */}
            <IoLogoLinkedin/>
          </a>
          <a
            href="mailto:asameh1500@gmail.com"
            target="_blank"
            rel="noreferrer"
          >
            {/* <img src={Mail} alt="mail" /> */}
            <AiFillMail/>
          </a>
          <a
            href="https://www.github.com/ahmedsameh74"
            target="_blank"
            rel="noreferrer"
          >
            {/* <img src={Github} alt="github" /> */}
            <AiFillGithub/>
          </a>
          <a
            href=" https://wa.me/+201094743313"
            target="_blank"
            rel="noreferrer"
          >
            {/* <img src={Whatsapp} alt="whatsapp" /> */}
            <AiOutlineWhatsApp/>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Contact